import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import TabButton from "../../../Components/common/TabButton/TabButton";
import ReactTableWrapper from "../../../Components/common/ReactTableWrapper/ReactTableWrapper";
import { getStoredPageSize } from "../../../Components/common/PageSizeSelect/PageSizeSelect";

import { hunterBoxHeader } from "../../../utils/constants/tableHeaders";

import {
  RequestHunterBoxList,
  SetHunterBoxActiveTab,
} from "../../../store/actions/integrationsActions";

const PAGE_SIZE = 10;
const TABLE_NAME = "hunterBox";

const HunterBoxList = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const hunterBoxList = useSelector((state) => state.integrations.hunterBoxList);
  const hunterBoxListLoading = useSelector((state) => state.integrations.hunterBoxListLoading);
  const pageCount = useSelector((state) => state.integrations.hunterBoxListPageCount);
  const activeTab = useSelector((state) => state.integrations.hunterBoxActiveTab);
  const isTabSwitching = useSelector((state) => state.integrations.hunterBoxTabSwitching);

  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(() => getStoredPageSize(TABLE_NAME, PAGE_SIZE));
  const [selectedTimeFilter, setSelectedTimeFilter] = useState(null);
  const [tableFilters, setTableFilters] = useState([]);

  useEffect(() => {
    if (selectedTimeFilter) {
      dispatch(
        RequestHunterBoxList({
          pageSize,
          pageNumber,
          selectedTimeFilter,
          filters: tableFilters,
        }),
      );
    }

    if (tableFilters.length === 0) {
      const interval = setInterval(() => {
        if (selectedTimeFilter) {
          dispatch(
            RequestHunterBoxList({
              pageNumber: pageNumber < 1 ? 1 : pageNumber,
              pageSize,
              selectedTimeFilter,
              filters: [],
            }),
          );
        }
      }, 20000);

      return () => clearInterval(interval);
    }
  }, [dispatch, pageNumber, pageSize, selectedTimeFilter, activeTab, tableFilters]);

  const rowClickHandler = (row) => {
    const redirectUrl = row?.original?.redirect_url;

    history.push(redirectUrl);
  };

  const filterChangeHandler = (newFilters) => setTableFilters(newFilters);

  const refreshHandler = () =>
    dispatch(
      RequestHunterBoxList({
        pageSize,
        pageNumber,
        selectedTimeFilter,
        filters: tableFilters,
      }),
    );

  return (
    <div className="hunterbox__list-container">
      <h2>Submissions</h2>
      <div className="hunterbox__table border" style={{ width: "100%" }}>
        <div className="button-block">
          <TabButton
            title="Latest"
            onClick={() => dispatch(SetHunterBoxActiveTab("Latest"))}
            active={activeTab}
          />
          <TabButton
            title="Malicious"
            onClick={() => dispatch(SetHunterBoxActiveTab("Malicious"))}
            active={activeTab}
          />
        </div>
        <ReactTableWrapper
          data={hunterBoxList}
          isDataLoading={hunterBoxListLoading}
          tableName={TABLE_NAME}
          columns={hunterBoxHeader}
          paginationButtons
          customPageSize={PAGE_SIZE}
          refreshConfig={{ show: true, onClickHandler: refreshHandler }}
          styles={{ table: isTabSwitching ? { opacity: "0.4" } : {} }}
          rowOnClickHandler={rowClickHandler}
          pagination={{
            manualPagination: true,
            totalPageCount: pageCount,
            serverSidePaginationNumber: pageNumber,
            setServerSidePaginationNumber: setPageNumber,
            onPageSizeChange: setPageSize,
          }}
          filterByTime={useMemo(
            () => ({
              show: true,
              label: "Filter by last: ",
              selectedTimeFilter: selectedTimeFilter,
              setSelectedTimeFilter: setSelectedTimeFilter,
            }),
            [selectedTimeFilter, setSelectedTimeFilter],
          )}
          onFilterChange={filterChangeHandler}
        />
      </div>
    </div>
  );
};

export default HunterBoxList;
